import React from "react";
import {Dialog} from "@unibuddy/patron";

type QuestionWrapperProps = {
    isOpen: boolean;
    onDismiss?: () => void;
    children: React.ReactNode;
};

export const PopupQuestionWrapper: React.FC<QuestionWrapperProps> = ({
    children,
    isOpen,
    onDismiss,
}) => {
    return (
        <Dialog isOpen={isOpen} onDismiss={onDismiss} size="large" verticalAlign="center">
            {children}
        </Dialog>
    );
};
